import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { canUseRole, getActiveRoleName, permissionDeniedMessage, requiredRoleFor, roleLabel } from '@/utils/permissions'

export function usePermissions() {
  const appStore = useAppStore()
  const authStore = useAuthStore()
  const currentRole = computed(() => getActiveRoleName(authStore))

  function can(permissionOrRole) {
    return canUseRole(currentRole.value, permissionOrRole)
  }

  function deny(permissionOrRole) {
    appStore.addError(permissionDeniedMessage(permissionOrRole))
    return false
  }

  function guard(permissionOrRole) {
    return can(permissionOrRole) || deny(permissionOrRole)
  }

  return {
    can,
    deny,
    guard,
    currentRole,
    requiredRoleFor,
    roleLabel
  }
}
